interface colorObject {
  100: string;
  200: string;
  300: string;
  400: string;
  500: string;
  600: string;
  700: string;
  800: string;
  900: string;
}

const blue: colorObject = {
  100: '#DEEFFC',
  200: '#B6DAF0',
  300: '#8CC8FB',
  400: '#60B3F7',
  500: '#1D93F3',
  600: '#1A85E4',
  700: '#1D73D2',
  800: '#1463C0',
  900: '#0A45A2'
}

const grey: colorObject = {
  100: '#F5F5F5',
  200: '#EEEEEE',
  300: '#DADADA',
  400: '#A7A7A7',
  500: '#696B6C',
  600: '#4F545E',
  700: '#41444E',
  800: '#303640',
  900: '#1D2026'
}

const red: colorObject = {
  100: '#FCEEEE',
  200: '#F9DEDC',
  300: '#F2B8B5',
  400: '#EC928E',
  500: '#DC362E',
  600: '#B3261E',
  700: '#8C1D18',
  800: '#601410',
  900: '#410E0B'
}

const yellow: colorObject = {
  100: '#FEF9EC',
  200: '#F8EBC8',
  300: '#F2D684',
  400: '#F2CC68',
  500: '#F2CC68',
  600: '#F2C45B',
  700: '#EBA74E',
  800: '#EA9A4A',
  900: '#E67E3C'
}

const green: colorObject = {
  100: '#EAF9F4',
  200: '#C0E4D6',
  300: '#95CFB9',
  400: '#54AA88',
  500: '#479A76',
  600: '#408C6A',
  700: '#3D7E5E',
  800: '#326E50',
  900: '#275137'
}

export const screenhubColor = {
  blue,
  grey,
  red,
  yellow,
  green
}
